// import { observer } from "mobx-react";
// import useStore from "../../../../hooks/useStore";
// import { useCallback, useState } from "react";
// import { Button, Modal } from "react-bootstrap";

// const LogBody = () => {
//   const {
//     formStore: { log },
//   } = useStore();
//   const [modalOpen, setModalOpen] = useState(false);
//   const [view, setView] = useState(null);

//   const closeModal = useCallback(() => {
//     setModalOpen(false);
//   }, []);
//   console.log("log", log);

//    // Function to render key-value pairs with proper design
//    const renderKeyValuePairs = (data, level = 0) => {
//     if (typeof data !== 'object' || data === null) {
//       return null;
//     }

//     return Object.entries(data).map(([key, value], index) => (
//       <div
//         key={index}
//         style={{
//           marginBottom: '10px',
//           paddingLeft: `${level * 20}px`, // Indentation for nested objects
//           borderLeft: level > 0 ? '1px solid #ccc' : 'none', // Add border for nested levels
//         }}
//       >
//          {!Number.isNaN(Number(key)) ? (
//           <span style={{ display: "none" }}>{key.charAt(0).toUpperCase() + key.slice(1)}:</span>
//         ) : (
//           <strong>{key.charAt(0).toUpperCase() + key.slice(1)}:</strong>
//         )}
//         {' '}
//         <div>
//           {typeof value === 'object' && value !== null ? (
//             <div style={{ backgroundColor: '#f8f9fa', padding: '10px', borderRadius: '5px' }}>
//               {renderKeyValuePairs(value, level + 1)} {/* Recursively handle nested objects */}
//             </div>
//           ) : (
//             value !== null ? value : 'null'
//           )}
//         </div>
//       </div>
//     ));
//   };


//   return (
//     <>
//       <tbody>
//         {log.length === 0 ? (
//           <tr>
//             <td colSpan={5}>
//               <div className="text-center">No records found</div>
//             </td>
//           </tr>
//         ) : (
//           log?.map((logItem, index) => (
//             <tr key={index}>
//               <td>{logItem?.user?.firstName}</td>
//               <td>{new Date(logItem.createdAt).toLocaleDateString("en-GB")}</td>
//               <td>{logItem.action}</td>
//               <td>{logItem.ip}</td>
//               <td>
//                 <button
//                   onClick={() => {
//                     setModalOpen(true);
//                     setView(logItem.request);
//                   }}
//                 >
//                   View
//                 </button>
//               </td>
//             </tr>
//           ))
//         )}
//       </tbody>
//       <Modal show={modalOpen} onHide={() => closeModal()}>
//         <Modal.Header closeButton>
//           {/* <Modal.Title>Log Details</Modal.Title> */}
//         </Modal.Header>
//         <Modal.Body>
//           {view ? (
//             <>
//               <p><strong>Log Data:</strong></p>
//               <div style={{ maxHeight: '450px', overflowY: 'auto' }}>
//                 {renderKeyValuePairs(view.body.data || view.query || view.body)}
//               </div>
//             </>
//           ) : (
//             <p>No details available.</p>
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={closeModal}>
//             Close
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </>
//   );
// };


// export default observer(LogBody);

import React, { useState } from "react";
import { observer } from "mobx-react";
import { toJS } from "mobx";
import { Modal, Button } from "react-bootstrap";
import * as XLSX from 'xlsx'; // Make sure to install xlsx package
import useStore from "../../../../hooks/useStore";

const LogBody = ({approvalStatus}) => {
  const {
    formStore: { log },
  } = useStore();
  const [showModal, setShowModal] = useState(false);
  const [selectedLog, setSelectedLog] = useState(null);
  const logList = toJS(log);



  // Function to extract key and value from the log data
  const extractKeyAndValue = (log) => {
   

    // If log is null or undefined
    if (!log) {
      console.error('Log is null or undefined');
      return [];
    }

    // Check different possible locations for the data
    const possibleDataLocations = [
      log.body?.data,
      log.data,
      log.request?.body?.data,
      log.query,
      log
    ];

    for (let dataSource of possibleDataLocations) {

      
      // If dataSource is an array (like in your example)
      if (Array.isArray(dataSource)) {
        const extractedData = dataSource.map(item => ({
          Key: item.key || '',
          Value: item.value?.value || JSON.stringify(item.value) || '',
          // ID: item.id || '',
          // Action: item.action || ''
        })).filter(item => item.Key);


        if (extractedData.length > 0) {
          return extractedData;
        }
      }
      
      // If dataSource is an object with numeric keys
      if (dataSource && typeof dataSource === 'object' && !Array.isArray(dataSource)) {
        const keys = Object.keys(dataSource);
        
        // Check if it's the structure from your example
        if (keys.every(key => !isNaN(Number(key)))) {
          const extractedData = keys.map(key => ({
            Key: dataSource[key].key || '',
            Value: dataSource[key].value?.value || JSON.stringify(dataSource[key].value) || '',
            // ID: dataSource[key].id || '',
            // Action: dataSource[key].action || ''
          }));

          
          return extractedData.filter(item => item.Key);
        }
      }
    }

    console.error('No suitable data found for export');
    return [];
  };

  // Function to export log data to Excel
  const exportToExcel = () => {
    try {
      // Ensure we have a selected log
      if (!selectedLog) {
        console.error('No log selected');
        alert('No log selected');
        return;
      }

      // Extract Key and Value pairs from the selected log
      const excelData = extractKeyAndValue(selectedLog);

      // Ensure we have data to export
      if (excelData.length === 0) {
        console.error('No data to export');
        alert('No data found to export');
        return;
      }

      // Create worksheet
      const worksheet = XLSX.utils.json_to_sheet(excelData);

      // Create workbook and add worksheet
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Log Details");

      // Export to Excel file
      const formId = selectedLog.formId || "unknown";
      XLSX.writeFile(workbook, `log_details_export_${formId}.xlsx`);
    } catch (error) {
      console.error('Export failed:', error);
      alert('Failed to export data. Check console for details.');
    }
  };

  // Function to render key-value pairs with proper design
  const renderKeyValuePairs = (data, level = 0) => {
    if (typeof data !== 'object' || data === null) {
      return null;
    }
    
    return Object.entries(data).map(([key, value], index) => (
      <div
        key={index}
        style={{
          marginBottom: '10px',
          paddingLeft: `${level * 20}px`, // Indentation for nested objects
          borderLeft: level > 0 ? '1px solid #ccc' : 'none', // Add border for nested levels
        }}
      >
        {!Number.isNaN(Number(key)) ? (
          <span style={{ display: "none" }}>{key.charAt(0).toUpperCase() + key.slice(1)}:</span>
        ) : (
          <strong>{key.charAt(0).toUpperCase() + key.slice(1)}:</strong>
        )}
        {' '}
        <div>
          {typeof value === 'object' && value !== null ? (
            <div style={{ backgroundColor: '#f8f9fa', padding: '10px', borderRadius: '5px' }}>
              {renderKeyValuePairs(value, level + 1)} {/* Recursively handle nested objects */}
            </div>
          ) : (
            value !== null ? value : 'null'
          )}
        </div>
      </div>
    ));
  };

  // Function to open modal and set selected log data
  const handleViewClick = (log) => {
    setSelectedLog(log);
    setShowModal(true);
  };

  // Function to close modal
  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedLog(null);
  };

  return (
    <>
      <tbody>
        {logList.length === 0 ? (
          <tr>
            <td colSpan={5}>
              <div className="text-center">No records found</div>
            </td>
          </tr>
        ) : (
          logList.map((logItem, index) => (
            <tr key={index}>
              <td>{logItem?.user?.firstName}</td>
              <td>{new Date(logItem.createdAt).toLocaleDateString("en-GB")}</td>
              <td>{logItem.action}</td>
              <td>{logItem.ip}</td>
              <td>
                <button
                  onClick={() => handleViewClick(logItem)}
                >
                  View
                </button>
              </td>
            </tr>
          ))
        )}
      </tbody>

      {/* Modal for Viewing Log Details */}
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Log Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedLog ? (
            <>
              <p><strong>Log Data:</strong></p>
              <div style={{ maxHeight: '450px', overflowY: 'auto' }}>
                {renderKeyValuePairs(selectedLog.request?.body?.data || 
                                     selectedLog.request?.query || 
                                     selectedLog.request?.body || 
                                     selectedLog)}
              </div>
            </>
          ) : (
            <p>No details available.</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button 
            variant="primary" 
            onClick={exportToExcel}
           // disabled={approvalStatus !== 'approved'}
          >
            Download Excel
          </Button>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default observer(LogBody);
